<template>
  <section
      :class="colourClass(backgroundColourObj)"
      class="blog-listing-hero push-v--desktop--small push-v--tablet--small push-v--mobile--small"
  >
    <div class="blog-listing-hero__content">
      <div class="container">
        <div class="blog-listing-hero__lockup">
          <div class="row">
            <div class="col-md-9 offset-md-1 col-lg-7 offset-lg-2">
              <span v-if="subtitle" class="blog-listing-hero__subtitle blog-listing-hero__animation--1">{{
                subtitle
              }}</span>
              <h1
                  v-if="title"
                  class="blog-listing-hero__title blog-listing-hero__animation--2 push-v--desktop--small push-v--tablet--x-small push-v--mobile--x-small"
              >
                {{ title }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="blog-listing-hero__wave">
      <a v-scroll-to="'#blog-listing'" class="blog-listing-hero__arrow" href="#" @keyup.stop=""><Arrow class="blog-listing-hero__icon" /></a>
    </div>
    <div :class="colourClass(backgroundShapeColourObj)" class="blog-listing-hero__background-shape-1" />
    <div class="blog-listing-hero__background-shape-2" />
  </section>
</template>

<script>
import { forceObject } from '~/utils/processor';

export default {
  props: {
    subtitle: { type: String, required: true, default: 'Welcome to' },
    title: { type: String, required: true, default: 'The Journal' },
    backgroundColour: {
      type: Array,
      default() {
        return [
          {
            name: 'Black',
          },
        ];
      },
    },
    backgroundShapeColour: {
      type: Array,
      default() {
        return [
          {
            name: 'Pale Orange',
          },
        ];
      },
    },
  },
  computed: {
    backgroundColourObj() {
      return forceObject(this.backgroundColour);
    },
    backgroundShapeColourObj() {
      return forceObject(this.backgroundShapeColour);
    },
  },
  methods: {
    stringToClass(string) {
      return string.toLowerCase().replace(' ', '-');
    },
    colourClass(colorObj) {
      if (colorObj && colorObj.name) {
        const { name } = colorObj;

        return `bg--${this.stringToClass(name)}`;
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_blog-listing-hero.scss';
</style>
